var vid = document.getElementById("hero-bgvideo");

if(typeof(vid) !== 'undefined' && vid !== null) {
	var pauseButton = document.querySelector("#Pause button");

	if (window.matchMedia('(prefers-reduced-motion)').matches) {
		vid.removeAttribute("autoplay");
		vid.pause();

		if (document.body.contains(pauseButton)) {
			pauseButton.innerHTML = "<i class='fa fa-play'></i>";
		}

	}

	function vidFade() {
		vid.classList.add("stopfade");
	}

	vid.addEventListener('ended', function () {
		// only functional if "loop" is removed
		vid.pause();
		// to capture IE10
		vidFade();
	});

	if (document.body.contains(pauseButton)) {
		pauseButton.addEventListener("click", function () {
			vid.classList.toggle("stopfade");
			if (vid.paused) {
				vid.play();
				pauseButton.innerHTML = "<i class='fa fa-pause'></i>";
			} else {
				vid.pause();
				pauseButton.innerHTML = "<i class='fa fa-play'></i>";
			}
		});
	}

}

